
/**
 *  Hostnames of the main site; any other hostname is treated as a seller's custom domain.
 *  Falls back to "localhost" for local dev; deployed builds fail in the Dockerfile if it's unset.
 */
const PLATFORM_HOSTS = (process.env.REACT_APP_PLATFORM_HOSTS || 'localhost')
  .split(',')
  .map((h) => h.trim().toLowerCase())
  // NOTE:  .filter(Boolean) is shorthand for .filter((h) => Boolean(h))
  .filter(Boolean);

export const isCustomDomainHost = (hostname = window.location.hostname) =>
  !PLATFORM_HOSTS.includes(hostname.toLowerCase());
